import { Box, Flex, Stack, useColorMode, useMediaQuery, Text, Button, Image } from '@chakra-ui/react'
import React from 'react'

function Header() {

    const { colorMode } = useColorMode()
    const isDark = colorMode === "dark"

    const { isNotSmallerScreen } = useMediaQuery("(min-width:600px)")

    return (
        <Stack>
            <Flex direction={ isNotSmallerScreen ? "row" : "column" } spacing="200px" p={isNotSmallerScreen ? "32" : "0"} alignSelf="flex-start">
                <Box mt={ isNotSmallerScreen ? "0" : "16"} align="flex-start">
                    <Text ml="8" fontSize="5xl" fontWeight="semibold" >Hi, I am</Text>
                    <Text ml="8" fontSize="7xl" fontWeight="bold" bgGradient="linear(to-r, cyan.400, blue.500, purple.600)" bgClip="text" >Aakash Pandit</Text>

                    <Text ml="8" mr="8" color={isDark ? "gray.200" : "black.500"}>
                        Hello. I am enthusiastic hardworking 25 years old Software Engineer living in Mumbai.
                        I have <b>4 years 4 months</b> of experience.
                    </Text>
                    <Text ml="8" mr="8" color={isDark ? "gray.200" : "black.500"}>
                        Have 3 years of experience in <b>Embedded Software Developer</b> where I was working on <b>C</b> and <b>C++</b>.
                    </Text>
                    <Text ml="8" mr="8" color={isDark ? "gray.200" : "black.500"}>
                        Now I am working as a <b>Software Engineer</b> in Procedure Technology where I am working on <b>Python Django</b> and <b>Django Rest Framework</b>.
                    </Text>
                    <Text ml="8" mr="8" color={isDark ? "gray.200" : "black.500"}>
                        Learning new skills and tricks are my daily rituals. Keen to learn <b>Golang</b>. 
                        <b> I have already uploaded 2 API on Heroku.</b>
                    </Text>
                    
                    <Button ml="8" mt={8} colorScheme="blue" onClick={() => window.open("https://drive.google.com/file/d/11NUijcyds0DCGDuYSCOmRK4wSf_ByGAa/view?usp=sharing")} >
                        Hire Me
                    </Button>

                    
                </Box>

                <Image alignSelf="center" mt={isNotSmallerScreen ? "0" : "12"} 
                    mb={isNotSmallerScreen ? "0" : "12"} borderRadius="full"
                    backgroundColor="transparent" boxShadow="lg" 
                    boxSize="300px" src="/Pic.jpg"
                />
                
            </Flex>
        </Stack>
    )
}

export default Header